import { Injectable } from '@angular/core';
import { ManagementVoyageModel } from '@data-layer/models/management';
import { PaginatedResultModel } from '@data-layer/models/common';
import { Observable } from 'rxjs';
import { enumVoyageStatus, enumVoyageType } from '@data-layer/enums/lcl';
import { map } from 'rxjs/operators';
import { VoyagesRepository } from '@data-layer/repositories';

@Injectable({ providedIn: 'root' })
export class LclHelperService {
  constructor(private voyagesRepository: VoyagesRepository) {}

  public getListAvailableVoyagesToMove(voyage: ManagementVoyageModel): Observable<ManagementVoyageModel[]> {
    return this.voyagesRepository
      .searchManagement({
        fromPort: voyage.route.departurePort.id,
        toPort: voyage.route.arrivalPort.id,
        statuses: [enumVoyageStatus.PUBLISHED, enumVoyageStatus.OPTIMIZED, enumVoyageStatus.OPTIMIZING],
      })
      .pipe(
        map((res: PaginatedResultModel<ManagementVoyageModel>) => {
          return res.items.filter((item: ManagementVoyageModel) => {
            return item.voyageType === enumVoyageType.COLOADING && item.status <= enumVoyageStatus.OPTIMIZED;
          });
        }),
      );
  }
}
